import { equals } from 'ramda';
import { memo, ReactElement, ReactNode } from 'react';

export interface PageTitleProps {
  /**
   * If set, will be displayed above the title in smaller text.
   */
  label?: ReactNode;

  /**
   * The title to be displayed on the left.
   */
  title: ReactNode;

  /**
   * If set, this element will be displayed on the right side of the header.
   */
  children?: ReactNode;

  /**
   * If set will add styles to the children container
   */
  childrenContainerStyle?: string;
}

function PageTitleMemo({
  label,
  title,
  children,
  childrenContainerStyle,
}: Readonly<PageTitleProps>): ReactElement<PageTitleProps> | null {
  return (
    <header className="bg-blue-grey-200 flex flex-col gap-y-2 md:flex-row py-2 md:min-h-16 md:items-center px-6">
      <div className="grow-1">
        <div className=" flex flex-col">
          {label && <div className="text-grey-200 text-xs font-normal">{label}</div>}
          {title && <div className="text-xl font-normal text-white">{title}</div>}
        </div>
      </div>
      {children && <div className={childrenContainerStyle}>{children}</div>}
    </header>
  );
}

export const PageTitle = memo(PageTitleMemo, equals);
